import { createLanguageContext } from './createLanguageContext';

export const { LanguageContextProvider, useLanguageContext } = createLanguageContext();
